<app-footer-scania *ngIf="(uiVersion$ | async) === 'scania'; else defaultFooter"></app-footer-scania>
<ng-template #defaultFooter>
  <app-footer-default></app-footer-default>
</ng-template>
